// extracted by mini-css-extract-plugin
export default {"wrapper":"SchoolLeadsSingleView_wrapper__+2mAu","inner":"SchoolLeadsSingleView_inner__N155s"};